/**
 * Format UTC timestamp to Brisbane time (Australia/Brisbane, AEST UTC+10)
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const BRISBANE_TZ = 'Australia/Brisbane';

export function formatBrisbaneTime(utcTimestamp: string | Date): string {
  return dayjs.utc(utcTimestamp).tz(BRISBANE_TZ).format('YYYY-MM-DD HH:mm:ss');
}
